module.exports = __webpack_public_path__ + "static/media/javascript.b591dcb3.png";